import React, { useRef } from "react";

export interface UseLocalFilePickerInputs {
  onFilesSelected: (files: File[]) => void;
  onClose: () => void;
  onRemoveFiles: (index: number) => void;
}

export function useLocalFilePicker({ onFilesSelected, onClose, onRemoveFiles }: UseLocalFilePickerInputs) {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    function resetFileInputForReselection() {
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
    const files = Array.from(event.target.files || []);
    onFilesSelected(files);
    onClose();
    resetFileInputForReselection();
  };
  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    const files = Array.from(event.dataTransfer.files);
    onFilesSelected(files);
    onClose();
  };
  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };
  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  const handleRemoveFile = (index: number) => {
    onRemoveFiles?.(index);
  };
  return { fileInputRef, handleFileSelect, handleDrop, handleDragOver, handleClick, handleRemoveFile };
}
